const TEST_EVENT_CODE = process.env.REACT_APP_META_TEST_CODE;

const getMetaParams = (params) => ({
  ...params,
  ...(TEST_EVENT_CODE && { test_event_code: TEST_EVENT_CODE })
});

export const trackRegistration = () => {
  if (!window.fbq) {
    console.warn('Meta Pixel (fbq) not initialized.');
    return;
  }

  window.fbq('track', 'CompleteRegistration', getMetaParams({
    method: 'email'
  }));
};
